let outsideClick;
export const ClosableDiv = {
    bind(el, binding, vnode) {
        outsideClick = (e) => {
            e.stopPropagation()
            const {owner, call} = binding.value
            const excludeEl = vnode.context.$refs[owner]

            if(!_.isUndefined(excludeEl)) {
                if(!el.contains(e.target) && !excludeEl.contains(e.target)) {
                    vnode.context[call]()
                }
            }
        }
        document.addEventListener('click', outsideClick)
    },
    unbind() {
        document.removeEventListener('click', outsideClick)
    }
}